import './custom-icons.css';

import React from 'react';
import { createIcon } from '@chakra-ui/react';

export const SEHomeNavHomeIcon = createIcon({
  displayName: 'SEHomeNavHomeIcon',
  path: (
    <svg width="33" height="30" viewBox="0 0 33 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.36 29.1598V17.8098H1L14.1 6.08984L27.36 17.8498H23.81V29.1598"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.7002 2.89062L18.9802 5.82063C20.9502 3.61063 24.3402 3.42062 26.5402 5.39062C28.7502 7.36062 28.9402 10.7506 26.9702 12.9506L30.1702 15.8106"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.5 5.36008L29.43 2.08008"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6202 4L22.4502 1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.4102 9.00961L31.3102 8.84961"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 33 30',
});

export const SEHomeEVChargerIcon = createIcon({
  displayName: 'SEHomeEVChargerIcon',
  path: (
    <svg width="33" height="31" viewBox="0 0 33 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M31.6497 18.7568C30.6966 17.7351 30.0444 17.3098 29.618 17.0262C29.363 16.8553 29.2209 16.7552 29.1331 16.6426C29.062 16.5425 28.9617 16.2881 28.8363 15.9754C28.1382 14.2865 26.8464 11.1381 24.2588 11.1381H13.465C10.8774 11.1381 9.58143 14.2865 8.88749 15.9754C8.75789 16.2881 8.66175 16.5425 8.59068 16.6426C8.50707 16.7552 8.36494 16.8553 8.10575 17.0262C7.67935 17.3098 7.02303 17.7351 6.07408 18.7568C5.12095 19.791 4.81161 21.8718 4.74054 24.2529C4.1511 24.2946 3.58675 24.3196 3.06002 24.2154C2.49567 24.1069 2.03165 23.8401 1.79336 23.4856C1.59271 23.1895 1.49238 22.76 1.47565 22.1429C1.44639 21.1295 1.62615 20.3039 2.01493 19.6867C2.37862 19.1029 2.95551 18.6484 3.57003 18.1688C4.07168 17.7727 4.59004 17.364 5.03735 16.8511C5.51391 16.3048 6.30819 15.2081 6.30819 14.0113V11.9513C8.18936 11.6135 9.62323 9.97054 9.62323 7.99395C9.62323 7.58945 9.29298 7.26002 8.88749 7.26002C8.48199 7.26002 8.15174 7.58945 8.15174 7.99395C8.15174 9.40342 7.00213 10.5502 5.58916 10.5502C4.17619 10.5502 3.02658 9.40342 3.02658 7.99395C3.02658 7.98144 3.02658 7.96893 3.02658 7.95642V5.6629H9.36823C9.76537 5.6629 10.0789 5.35015 10.0789 4.954C10.0789 4.55784 9.76537 4.24509 9.36823 4.24509H8.65756V0.708905C8.65756 0.312752 8.34404 0 7.9469 0C7.54976 0 7.23623 0.312752 7.23623 0.708905V4.24926H4.39775V0.708905C4.39775 0.312752 4.08422 0 3.68708 0C3.28994 0 2.97641 0.312752 2.97641 0.708905V4.24926H2.26575C1.86861 4.24926 1.55508 4.56201 1.55508 4.95817V7.96059C1.55508 7.96059 1.55508 7.98561 1.55508 7.99812C1.55508 9.9622 2.97223 11.5969 4.84087 11.9471V14.0113C4.84087 14.5326 4.49808 15.2331 3.92536 15.8962C3.57003 16.3048 3.12691 16.6509 2.6587 17.0221C1.9773 17.56 1.27082 18.1146 0.773349 18.9111C0.221537 19.7785 -0.0334663 20.8793 -2.32169e-05 22.1804C0.0166983 22.7517 0.0919454 23.5899 0.564329 24.2946C1.02417 24.9785 1.80591 25.458 2.7674 25.6457C3.15199 25.7207 3.52823 25.7458 3.90028 25.7458C4.17619 25.7458 4.44373 25.7291 4.71128 25.7124C4.71128 26.1044 4.71964 26.5005 4.728 26.8967V27.6056C4.728 29.1652 5.16694 30.9958 6.42106 30.9958H9.07978C10.4593 30.9958 10.986 29.2069 11.1825 28.1602H12.3907H17.3361C17.7332 28.1602 18.0467 27.8475 18.0467 27.4513C18.0467 27.0552 17.7332 26.7424 17.3361 26.7424H12.7502H10.5847C10.2169 26.7424 9.91586 27.0135 9.87406 27.3804C9.74447 28.5564 9.30552 29.578 9.09233 29.578H6.54647C6.41688 29.3945 6.14933 28.7398 6.14933 27.6056V26.8675C6.12007 25.237 6.03646 20.9085 7.115 19.7326C7.93854 18.8402 8.48199 18.4857 8.87913 18.2272C9.17593 18.027 9.4602 17.8436 9.70266 17.5308C9.8448 17.3473 9.95767 17.0763 10.1876 16.5217C10.7143 15.2289 11.8096 12.5643 13.4441 12.5643H24.2671C25.9017 12.5643 26.9969 15.2331 27.5237 16.5217C27.7494 17.0763 27.8665 17.3432 28.0086 17.5308C28.2511 17.8436 28.5353 18.027 28.8321 18.2272C29.2293 18.4816 29.7727 18.836 30.5963 19.7326C31.679 20.9085 31.5912 25.237 31.5619 26.8675V27.6056C31.5619 28.7398 31.2902 29.3945 31.1648 29.578H28.6189C28.4057 29.578 27.9668 28.5564 27.8372 27.3804C27.7954 27.0135 27.4944 26.7424 27.1265 26.7424H24.3424H20.3794C19.9822 26.7424 19.6687 27.0552 19.6687 27.4513C19.6687 27.8475 19.9822 28.1602 20.3794 28.1602H23.3893H26.5287C26.7294 29.2111 27.2519 30.9958 28.6315 30.9958H31.2902C32.5401 30.9958 32.9833 29.1652 32.9833 27.6056V26.8967C33.0543 23.4939 32.9414 20.1579 31.6455 18.7526L31.6497 18.7568Z"
        fill="currentColor"
      />
      <path
        d="M10.8232 22.2058C10.426 22.1641 10.1 22.4893 10.0707 22.873C10.0582 23.2691 10.355 23.5944 10.7396 23.6111L14.18 23.782H14.2218C14.5897 23.782 14.9032 23.486 14.9325 23.1148C14.945 22.7187 14.6482 22.3934 14.2636 22.3767L10.8232 22.2058Z"
        fill="currentColor"
      />
      <path
        d="M23.607 23.777L27.0642 23.6061C27.4613 23.5936 27.7623 23.2516 27.733 22.868C27.7205 22.4718 27.407 22.1299 26.9931 22.2008H26.9806L23.5234 22.3717C23.1262 22.3843 22.8252 22.7262 22.8545 23.1098C22.867 23.4935 23.1806 23.777 23.5652 23.777H23.607Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 33 31',
});

export const SEHomeNavActivityIcon = createIcon({
  displayName: 'SEHomeNavActivityIcon',
  path: (
    <svg width="32" height="29" viewBox="0 0 32 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.95 27.58H17.47V22.15H29.24C29.79 22.15 30.24 21.7 30.24 21.15L30.28 2C30.28 1.45 29.83 1 29.28 1H2.04C1.49 1 1.04 1.45 1.04 2L1 21.15C1 21.7 1.45 22.15 2 22.15H13.74V27.58H6.27"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.74023 12.4396H11.0702L13.3902 17.5296L17.6802 5.34961L20.6202 12.4196H24.4802"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  viewBox: '0 0 32 29',
});

export const SEHomeNavNotificationsIcon = createIcon({
  displayName: 'SEHomeNavNotificationsIcon',
  path: (
    <svg width="27" height="33" viewBox="0 0 27 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.66992 27.8789C9.66992 28.7789 10.0799 29.6289 10.8199 30.2689C11.5599 30.8989 12.5599 31.2589 13.5999 31.2589C14.6399 31.2589 15.6399 30.8989 16.3799 30.2689C17.1199 29.6389 17.5299 28.7789 17.5299 27.8789"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.21 25.5682L23.11 22.2182V13.2982C23.11 8.0882 18.81 3.4082 13.6 3.4082C8.4 3.4082 4.1 8.0882 4.1 13.2982V22.2182L1 25.5682H26.21Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M13.6104 1V3.22" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  viewBox: '0 0 27 33',
});

export const ErrorStatusIcon = createIcon({
  displayName: 'ErrorStatusIcon',
  path: (
    <svg width="234" height="234" viewBox="0 0 234 234" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="116.536" cy="116.536" r="115.536" stroke="#FF5B44" strokeWidth="2" />
      <ellipse cx="116.571" cy="116.536" rx="107.571" ry="107.571" fill="url(#paint0_radial_5367_51090)" />
      <path
        d="M110.754 68.879C109.082 70.25 108.245 72.3065 108.245 75.0484L110.754 126.46C110.754 128.653 111.451 130.298 112.845 131.395C114.239 132.492 115.772 133.04 117.444 133.04C119.396 133.04 121.068 132.492 122.462 131.395C123.856 130.024 124.413 128.379 124.135 126.46L126.643 75.0484C126.643 72.8548 125.807 70.7984 124.135 68.879C122.462 66.9597 120.232 66 117.444 66C114.657 66 112.427 66.9597 110.754 68.879ZM124.971 165.532V165.121C127.201 163.202 128.177 160.734 127.898 157.718C127.898 154.702 126.922 152.371 124.971 150.726C122.741 148.532 120.232 147.435 117.444 147.435C114.935 147.435 112.427 148.532 109.918 150.726C107.688 152.645 106.712 154.976 106.991 157.718C106.712 160.734 107.688 163.339 109.918 165.532C112.148 167.177 114.657 168 117.444 168C120.232 168 122.741 167.177 124.971 165.532Z"
        fill="#FF5B44"
      />
      <defs>
        <radialGradient
          id="paint0_radial_5367_51090"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(116.572 116.536) rotate(93.4766) scale(107.77 107.77)"
        >
          <stop offset="0.854167" stopColor="#FF5B44" stopOpacity="0" />
          <stop offset="1" stopColor="#FF5B44" stopOpacity="0.8" />
        </radialGradient>
      </defs>
    </svg>
  ),
  viewBox: '0 0 234 234',
});

export const ExclamationIcon = createIcon({
  displayName: 'ExclamationIcon',
  path: (
    <svg width="30" height="110" viewBox="0 0 30 110" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.753998,7.878998 C6.082001,9.25 5.245003,11.306503 5.245003,14.048401 L7.753998,65.459999 C7.753998,67.653 8.450996,69.298004 9.845001,70.395004 C11.238998,71.492004 12.772003,72.039993 14.444,72.039993 C16.396004,72.039993 18.068001,71.492004 19.461998,70.395004 C20.856003,69.024002 21.413002,67.378998 21.135002,65.459999 L23.642998,14.048401 C23.642998,11.854797 22.806999,9.798401 21.135002,7.878998 C19.461998,5.959702 17.232002,5 14.444,5 C11.656998,5 9.427002,5.959702 7.753998,7.878998 M21.971001,104.531998 V104.121002 C24.200996,102.201996 25.177002,99.733994 24.898003,96.718002 C24.898003,93.701996 23.921997,91.371002 21.971001,89.725998 C19.740997,87.531998 17.232002,86.434998 14.444,86.434998 C11.934998,86.434998 9.427002,87.531998 6.917999,89.725998 C4.688004,91.645004 3.711998,93.975998 3.990997,96.718002 C3.711998,99.733994 4.688004,102.339005 6.917999,104.531998 C9.148003,106.177002 11.656998,107 14.444,107 C17.232002,107 19.740997,106.177002 21.971001,104.531998 "
        fill="#FF5B44"
      />
    </svg>
  ),
  viewBox: '0 0 30 110',
});

export const CircleIcon = createIcon({
  displayName: 'CircleIcon',
  path: (
    <svg width="234" height="234" viewBox="0 0 234 234" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="117" cy="117" r="115" stroke="currentColor" strokeWidth="2" />
      <ellipse cx="117" cy="117" rx="107" ry="107" fill="url(#base)" />

      <defs>
        <radialGradient
          id="base"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(117 117) rotate(93.4766) scale(107.77 107.77)"
        >
          <stop offset="0.854167" stopColor="currentColor" stopOpacity="0" />
          <stop offset="1" stopColor="currentColor" />
        </radialGradient>
        <radialGradient
          id="overlay"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(117 117) rotate(93.4766) scale(107.77 107.77)"
        >
          <stop offset="0.854167" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="1" stopColor="#D9D9D9" />
        </radialGradient>
      </defs>
    </svg>
  ),
  viewBox: '0 0 234 234',
});

export const GridIcon = createIcon({
  displayName: 'GridIcon',
  path: (
    <svg width="94" height="96" viewBox="0 0 94 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M93.334 92.2574C93.1221 92.0444 92.8799 91.8922 92.6074 91.8009C92.3349 91.6792 92.0322 91.6488 91.7597 91.6488H81.1034L77.8641 80.7556C76.6834 80.9686 75.5027 81.0903 74.2615 81.0903C73.9891 81.0903 73.7166 81.0599 73.4441 81.0599L75.6238 88.393L50.7085 70.5014L54.5533 67.7325C53.9781 66.3328 53.5845 64.8418 53.3121 63.29L46.9849 67.8238L30.5765 56.0482L46.9849 44.2422L55.2496 50.1756C55.9156 48.8672 56.6725 47.6501 57.5807 46.4938L50.7085 41.5645L59.7604 35.0529L61.9401 42.3556C63.151 41.5036 64.4225 40.7429 65.7849 40.1344L61.3346 25.1334H87.7939V31.5233C87.7939 32.0406 88.0663 32.5578 88.4599 32.9534C89.2773 33.7445 90.6396 33.7141 91.457 32.9534C91.8506 32.5578 92.0928 32.0406 92.123 31.4929V22.9426C92.123 22.5775 92.0322 22.2428 91.8506 21.9385C91.6689 21.6342 91.4267 21.3604 91.124 21.1474L59.4576 0.365135C59.0944 0.121712 58.7008 0 58.277 0H35.6625C35.2386 0 34.8451 0.121712 34.4818 0.365135L2.87601 21.2082C2.57327 21.4212 2.30081 21.6647 2.14944 21.9994C1.96779 22.3036 1.87697 22.6688 1.87697 23.0339V31.6146C1.87697 32.1319 2.14944 32.6491 2.543 33.0447C3.36039 33.8358 4.72271 33.8054 5.50982 33.0447C5.90338 32.6491 6.14557 32.1319 6.17585 31.5842V25.2247H32.6351L12.8966 91.6488H2.17971C1.90725 91.6488 1.66506 91.6792 1.42287 91.7705C1.1504 91.8618 0.908213 92.0139 0.696296 92.2269C0.48438 92.4399 0.302738 92.6834 0.181643 92.9572C0.0605475 93.2311 0 93.5049 0 93.8092C0 94.1135 0.0605475 94.3873 0.181643 94.6612C0.302738 94.935 0.454106 95.1785 0.666023 95.3914C0.877939 95.6044 1.12013 95.7566 1.39259 95.8479C1.66506 95.9696 1.96779 96 2.27053 96H91.6992C92.0322 96 92.3047 96 92.5771 95.8783C92.8496 95.787 93.1221 95.6044 93.3037 95.4219C93.5156 95.2089 93.667 94.9655 93.8184 94.6916C93.9395 94.4178 94 94.1439 94 93.8396C94 93.5353 93.9395 93.2615 93.8184 92.9876C93.6973 92.7138 93.5156 92.4704 93.3037 92.2574H93.334ZM60.6081 6.26815L82.7382 20.8431H60.6081V6.26815ZM37.7514 4.35119H56.2789V20.8431H37.7514V4.35119ZM37.1762 25.1943H56.7936L58.4283 30.7017L46.9849 38.9173L35.5414 30.6713L37.1762 25.1943ZM11.2618 20.8431L33.4222 6.23772V20.8431H11.2618ZM34.2396 35.0529L43.2915 41.5645L29.3353 51.6057L34.2396 35.0834V35.0529ZM27.1858 58.878L43.3217 70.471L18.4367 88.3626L27.2161 58.878H27.1858ZM21.2522 91.6488L47.0151 73.1487L72.7781 91.6488H21.2522Z"
        fill="currentColor"
      />
      <g id="circle" transform="translate(51,41)">
        <path
          d="M19.2609 38.5643C8.93759 38.5643 0.521484 30.1357 0.521484 19.7294C0.521484 9.32306 8.90732 0.894531 19.2609 0.894531C29.6146 0.894531 38.0004 9.32306 38.0004 19.7294C38.0004 30.1357 29.6146 38.5643 19.2609 38.5643ZM19.2609 5.18487C11.2687 5.18487 4.75981 11.7269 4.75981 19.7598C4.75981 27.7928 11.2687 34.3348 19.2609 34.3348C27.2532 34.3348 33.7621 27.7928 33.7621 19.7598C33.7621 11.7269 27.2532 5.18487 19.2609 5.18487Z"
          fill="currentColor"
        />
      </g>
      <g id="cross" transform="translate(60,50)">
        <path
          d="M2.2407 11.2078C1.87678 10.8439 1.64207 10.308 1.64349 9.74997C1.64633 8.63398 2.5715 7.7088 3.709 7.68445L16.8004 7.65121C17.9164 7.64838 18.8369 8.56887 18.834 9.68486C18.8312 10.8008 17.906 11.726 16.7685 11.7504L3.67713 11.7836C3.11914 11.785 2.60461 11.5717 2.21929 11.1864L2.2407 11.2078Z"
          fill="currentColor"
        />
        <path
          d="M8.76976 17.7369C8.40585 17.373 8.17114 16.837 8.17256 16.279L8.2058 3.18766C8.20863 2.07167 9.13381 1.1465 10.2713 1.12215C11.3873 1.11931 12.3078 2.0398 12.305 3.15579L12.2717 16.2472C12.2689 17.3632 11.3437 18.2883 10.2062 18.3127C9.64821 18.3141 9.13368 18.1008 8.74836 17.7155L8.76976 17.7369Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  viewBox: '0 0 94 96',
});

export const OutlineGradientIcon = createIcon({
  displayName: 'OutlineGradientIcon',
  path: (
    <svg width="230" height="230" viewBox="0 0 230 230" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="112" cy="112" r="97" stroke="currentColor" strokeWidth="1" />
      <ellipse cx="112" cy="112" rx="90" ry="90" fill="url(#innerGradient)" />
      <defs>
        <radialGradient
          id="innerGradient"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(112 112) scale(90 90)"
        >
          <stop offset="0.854167" stopColor="currentColor" stopOpacity="0" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.8" />
        </radialGradient>
      </defs>
    </svg>
  ),
  viewBox: '0 0 230 230',
});

export const OutlineGradientIconAnimated = createIcon({
  displayName: 'OutlineGradientIcon',
  path: (
    <svg width="230" height="230" viewBox="0 0 230 230" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="112" cy="112" r="97" stroke="currentColor" strokeWidth="1" id="pulsating-circle" />
      <ellipse cx="112" cy="112" rx="90" ry="90" fill="url(#innerGradient)" />
      <defs>
        <radialGradient
          id="innerGradient"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(112 112) scale(90 90)"
        >
          <stop offset="0.854167" stopColor="currentColor" stopOpacity="0" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.8" />
        </radialGradient>
      </defs>
    </svg>
  ),
  viewBox: '0 0 230 230',
});

export const SearchProviderIcon = createIcon({
  displayName: 'SearchProviderIcon',
  path: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path
        d="M25.9688 25.0312C26.2188 25.2812 26.2188 25.7188 25.9688 25.9688C25.8438 26.0938 25.6562 26.1562 25.5 26.1562C25.3125 26.1562 25.1562 26.0938 25.0312 25.9688L20.1562 21.0938C18.625 22.4062 16.6562 23.1875 14.5 23.1875C9.71875 23.1875 5.84375 19.2812 5.84375 14.5C5.84375 9.71875 9.71875 5.84375 14.5 5.84375C19.2812 5.84375 23.1875 9.71875 23.1875 14.5C23.1875 16.6562 22.4062 18.625 21.0938 20.1562L25.9688 25.0312ZM7.1875 14.5C7.1875 18.5625 10.4688 21.8438 14.5 21.8438C16.5 21.8438 18.2812 21.0625 19.625 19.7812C19.625 19.75 19.6562 19.7188 19.6875 19.6875C19.7188 19.6562 19.75 19.625 19.7812 19.625C21.0625 18.2812 21.8438 16.5 21.8438 14.5C21.8438 10.4688 18.5625 7.1875 14.5 7.1875C10.4688 7.1875 7.1875 10.4688 7.1875 14.5ZM14.5 8.5C14.875 8.5 15.1875 8.8125 15.1875 9.1875C15.1875 9.53125 14.875 9.84375 14.5 9.84375C11.9375 9.84375 9.84375 11.9375 9.84375 14.5C9.84375 14.875 9.53125 15.1875 9.1875 15.1875C8.8125 15.1875 8.5 14.875 8.5 14.5C8.5 11.1875 11.1875 8.5 14.5 8.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  viewBox: '0 0 32 32',
});

export const DeleteIcon = createIcon({
  displayName: 'DeleteIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="34" fill="none">
      <path
        fill="currentColor"
        d="M1.64 9.47v18.31c.08 3.03 2.66 5.46 5.69 5.39h13.08c3.05.08 5.63-2.35 5.71-5.41V9.47c0-.43-.35-.79-.79-.79-.44 0-.79.35-.79.79v18.31c-.12 2.16-1.89 3.81-3.99 3.81H7.35c-2.17.13-4.01-1.58-4.14-3.76V9.47c0-.43-.35-.79-.79-.79-.44 0-.79.35-.79.79h.01ZM18.79 0H8.97c-.43 0-.79.35-.79.79v4.12H.79c-.43 0-.79.35-.79.79 0 .44.35.79.79.79h26.19c.43 0 .79-.35.79-.79 0-.44-.35-.79-.79-.79h-7.4V.79c0-.43-.35-.79-.79-.79ZM18 4.91H9.76V1.57h8.25v3.34H18Z"
      />
      <path
        fill="currentColor"
        d="M8.47 11.25c-.43 0-.79.35-.79.79v13.97c0 .43.35.79.79.79.44 0 .79-.35.79-.79V12.04c0-.43-.35-.79-.79-.79ZM13.88 11.25c-.43 0-.79.35-.79.79v13.97c0 .43.35.79.79.79.44 0 .79-.35.79-.79V12.04c0-.43-.35-.79-.79-.79ZM19.3 11.25c-.43 0-.79.35-.79.79v13.97c0 .43.35.79.79.79.44 0 .79-.35.79-.79V12.04c0-.43-.35-.79-.79-.79Z"
      />
      <path
        fill="currentColor"
        d="M14.67 26.01V12.04c0-.43-.35-.79-.79-.79-.44 0-.79.35-.79.79v13.97c0 .43.35.79.79.79.44 0 .79-.35.79-.79Z"
      />
    </svg>
  ),
  viewBox: '0 0 28 34',
});

export const ArchiveIcon = createIcon({
  displayName: 'ArchiveIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none">
      <path
        fill="currentColor"
        d="M2.66 27.33h21.88c.48 0 .79-.3.79-.79V7.19h1.09c.48 0 .79-.3.79-.79V.79c0-.38-.3-.79-.79-.79H.79C.3 0 0 .3 0 .79V6.4c0 .48.31.79.79.79h1.08v19.35c0 .48.31.79.79.79Zm21.1-1.47H3.44V7.19h20.32v18.67ZM1.57 5.62V1.57h24.06v4.05H1.57Z"
      />
      <path
        fill="currentColor"
        d="M17.54 10.93H9.65c-.48 0-.79.3-.79.79 0 .49.3.79.79.79h7.89c.48 0 .79-.31.79-.79 0-.48-.31-.79-.79-.79Z"
      />
    </svg>
  ),
  viewBox: '0 0 28 28',
});

export const SEHomeWifiIcon = createIcon({
  displayName: 'SEHomeWifiIcon',
  viewBox: '0 0 34 25',
  path: (
    <svg width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M16.9984 0C23.2028 1.86945e-05 29.0471 2.28672 33.4853 6.45284L33.7165 6.67268L33.7356 6.69463L33.7781 6.74362L33.8052 6.7748L33.8279 6.80884C33.9301 6.96163 34 7.1542 34 7.36591C34 7.62832 33.8955 7.8869 33.6954 8.07854L33.6957 8.07886L31.3218 10.3625L31.3186 10.3657C31.1261 10.5482 30.8723 10.6463 30.6126 10.6463C30.3596 10.6462 30.1018 10.5524 29.9067 10.3625L29.7442 10.2082C26.3138 6.98826 21.7973 5.21561 16.9984 5.21559C12.1234 5.21559 7.54291 7.04483 4.09331 10.3657L4.09299 10.3653C3.89576 10.5573 3.63408 10.6497 3.38736 10.6498C3.13404 10.6498 2.876 10.5535 2.6814 10.3688L2.67789 10.3657L0.304284 8.08204L0.304603 8.08172C0.117013 7.90209 0.0134956 7.66373 0.00127716 7.4184L0 7.36909L0.00127716 7.31723C0.0149241 7.06053 0.129324 6.83046 0.296302 6.66409L0.300133 6.65995L0.304284 6.65613C4.76731 2.36001 10.6987 0 16.9984 0ZM16.9984 1.3031C11.141 1.3031 5.6342 3.45499 1.44766 7.37068L3.38672 9.23657C7.0601 5.79863 11.8845 3.91249 16.9984 3.91249C22.1121 3.91251 26.9392 5.79873 30.6126 9.23339L32.552 7.3675C28.3655 3.455 22.8589 1.30312 16.9984 1.3031Z"
          fill="currentColor"
        />
        <path
          d="M16.7342 7.82506C12.6973 7.89093 8.90311 9.46575 5.9882 12.2924L7.9148 14.228C10.3744 11.8642 13.588 10.5649 16.9983 10.5649C20.4085 10.5649 23.6219 11.8644 26.0815 14.228L28.0062 12.294C25.0278 9.40971 21.1323 7.82506 16.9983 7.82506H16.7342ZM29.4388 12.2914C29.4388 12.5712 29.3221 12.8158 29.154 12.9917L29.1492 12.9964L29.1448 13.0012L26.8005 15.3564L26.7986 15.3583C26.6134 15.5429 26.3565 15.6535 26.0844 15.6535C25.8301 15.6535 25.5664 15.5582 25.3682 15.3561C23.1262 13.1037 20.1576 11.868 16.9983 11.868C13.839 11.868 10.8704 13.104 8.62841 15.3564L8.6265 15.3583C8.44124 15.5429 8.18435 15.6535 7.91224 15.6535C7.65796 15.6535 7.39431 15.5582 7.19607 15.3561L4.85184 13.0012L4.85024 12.9993L4.84833 12.9977C4.46294 12.6045 4.46301 11.9755 4.84833 11.5823L4.85024 11.5804L4.85184 11.5785L5.0051 11.4267C8.2347 8.25987 12.4872 6.51878 16.9983 6.51877H17.6522V6.53436C21.9907 6.69716 26.0519 8.47775 29.1444 11.5817C29.3447 11.7787 29.4388 12.0397 29.4388 12.2914Z"
          fill="currentColor"
        />
        <path
          d="M17.0048 13.1874C19.9615 13.1874 22.7466 14.3448 24.8401 16.4439L24.8759 16.4814C25.2352 16.8776 25.2234 17.4894 24.8411 17.8717L24.8414 17.872L22.4675 20.2504L22.455 20.2628C22.2738 20.4349 22.0237 20.5466 21.7491 20.5466C21.4879 20.5466 21.2278 20.4471 21.0316 20.2517L21.0304 20.2504C19.9486 19.1667 18.5226 18.5726 17.0016 18.5726C15.4805 18.5726 14.0545 19.1668 12.9727 20.2504L12.9603 20.2628C12.779 20.4349 12.529 20.5466 12.2543 20.5466C11.9931 20.5466 11.733 20.4471 11.5369 20.2517L11.5356 20.2504L9.16201 17.872L9.16233 17.8717C8.9852 17.6946 8.88059 17.4551 8.86826 17.2081L8.86699 17.1588L8.87178 17.0611C8.89357 16.835 8.99119 16.616 9.16201 16.4452C11.2557 14.3453 14.041 13.1874 16.9984 13.1874H17.0048ZM16.9984 14.4905C14.4874 14.4905 12.1204 15.435 10.2971 17.1616L12.2588 19.1268C13.5561 17.9292 15.2275 17.2695 17.0016 17.2695C18.7755 17.2695 20.4467 17.9293 21.744 19.1268L23.7057 17.1616C21.8824 15.4352 19.5156 14.4905 17.0048 14.4905H16.9984Z"
          fill="currentColor"
        />
        <path
          d="M17.0049 19.9082C18.2081 19.9082 19.3578 20.3166 20.2336 21.0786L20.2744 21.1165C20.6721 21.5013 20.6721 22.1204 20.2744 22.5051L20.2336 22.5427L17.7096 24.7382L17.7086 24.7391C17.5091 24.912 17.2567 25 17.0017 25C16.7589 25 16.4989 24.9192 16.2935 24.7379L13.7695 22.5427L13.7698 22.5424C13.318 22.1495 13.3175 21.4732 13.7686 21.0799C14.642 20.3165 15.7922 19.9082 16.9982 19.9082H17.0049ZM16.9982 21.2113C16.2273 21.2113 15.5103 21.4319 14.934 21.8256L17.0014 23.624L19.0682 21.8262C18.4893 21.4319 17.7726 21.2113 17.0049 21.2113H16.9982Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
});

export const SEHomeEthernetIcon = createIcon({
  displayName: 'SEHomeEthernetIcon',
  viewBox: '0 0 34 33',
  path: (
    <svg width="34" height="33" viewBox="0 0 34 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M11.5799 27.6485H22.4201C22.7968 27.6485 23.1015 27.3438 23.1015 26.9672V24.3855H25.3921C25.7688 24.3855 26.0735 24.0808 26.0735 23.7041V19.8419H29.0044C29.3811 19.8419 29.6858 19.5372 29.6858 19.1605V5.86868C29.6858 5.49204 29.3776 5.18731 29.001 5.18731H4.99557C4.61893 5.18731 4.3142 5.49204 4.3142 5.86868V19.1571C4.3142 19.5337 4.61893 19.8385 4.99557 19.8385H7.92649V23.7007C7.92649 24.0773 8.23122 24.3821 8.60785 24.3821H10.8985V26.9637C10.8985 27.3404 11.2032 27.6451 11.5799 27.6451V27.6485ZM9.28922 23.0193V19.1571C9.28922 18.7805 8.98449 18.4757 8.60785 18.4757H5.67694V6.55347H28.3231V18.4757H25.3921C25.0155 18.4757 24.7108 18.7805 24.7108 19.1571V23.0193H22.4201C22.0435 23.0193 21.7388 23.3241 21.7388 23.7007V26.2824H12.2647V23.7007C12.2647 23.3241 11.9599 23.0193 11.5833 23.0193H9.28922Z"
          fill="currentColor"
        />
        <path
          d="M31.4526 0H2.54743C1.14361 0 0 1.14361 0 2.54743V30.2884C0 31.6922 1.14361 32.8358 2.54743 32.8358H31.4526C32.8564 32.8358 34 31.6922 34 30.2884V2.54743C34 1.14361 32.8564 0 31.4526 0ZM32.6338 30.2884C32.6338 30.939 32.1031 31.4697 31.4526 31.4697H2.54743C1.89688 31.4697 1.36616 30.939 1.36616 30.2884V2.54743C1.36616 1.89688 1.89688 1.36616 2.54743 1.36616H31.4526C32.1031 1.36616 32.6338 1.89688 32.6338 2.54743V30.2884Z"
          fill="currentColor"
        />
        <path
          d="M24.8649 9.09063C24.4882 9.09063 24.1835 9.39537 24.1835 9.772V13.8499C24.1835 14.2266 24.4882 14.5313 24.8649 14.5313C25.2415 14.5313 25.5462 14.2266 25.5462 13.8499V9.772C25.5462 9.39537 25.2415 9.09063 24.8649 9.09063Z"
          fill="currentColor"
        />
        <path
          d="M20.9341 9.09063C20.5575 9.09063 20.2528 9.39537 20.2528 9.772V13.8499C20.2528 14.2266 20.5575 14.5313 20.9341 14.5313C21.3108 14.5313 21.6155 14.2266 21.6155 13.8499V9.772C21.6155 9.39537 21.3108 9.09063 20.9341 9.09063Z"
          fill="currentColor"
        />
        <path
          d="M17 9.09063C16.6234 9.09063 16.3186 9.39537 16.3186 9.772V13.8499C16.3186 14.2266 16.6234 14.5313 17 14.5313C17.3766 14.5313 17.6814 14.2266 17.6814 13.8499V9.772C17.6814 9.39537 17.3766 9.09063 17 9.09063Z"
          fill="currentColor"
        />
        <path
          d="M13.0659 9.09063C12.6892 9.09063 12.3845 9.39537 12.3845 9.772V13.8499C12.3845 14.2266 12.6892 14.5313 13.0659 14.5313C13.4425 14.5313 13.7472 14.2266 13.7472 13.8499V9.772C13.7472 9.39537 13.4425 9.09063 13.0659 9.09063Z"
          fill="currentColor"
        />
        <path
          d="M9.13172 9.09063C8.75509 9.09063 8.45035 9.39537 8.45035 9.772V13.8499C8.45035 14.2266 8.75509 14.5313 9.13172 14.5313C9.50836 14.5313 9.81309 14.2266 9.81309 13.8499V9.772C9.81309 9.39537 9.50836 9.09063 9.13172 9.09063Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
});

export const EditIcon = createIcon({
  displayName: 'EditIcon',
  viewBox: '0 0 29 30',
  path: (
    <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M24.76 15.74C24.17 15.74 23.68 16.23 23.68 16.84V26.51C23.68 27.1101 23.2 27.6101 22.6 27.6101H3.23C2.64 27.6101 2.15 27.1201 2.15 26.51V4.60005C2.15 4.00005 2.63 3.50005 3.23 3.50005H14.88C15.47 3.50005 15.96 3.01005 15.96 2.40005C15.96 1.79005 15.48 1.30005 14.88 1.30005H3.23C1.45 1.31005 0 2.78005 0 4.60005V26.5C0 28.31 1.45 29.7901 3.23 29.7901H22.6C24.38 29.7901 25.83 28.32 25.83 26.5V16.83C25.83 16.23 25.35 15.73 24.75 15.73L24.76 15.74Z"
          fill="currentColor"
        />
        <path
          d="M10.3699 15.04C10.1699 15.04 9.96989 14.96 9.80989 14.81C9.49989 14.5 9.49989 13.99 9.80989 13.68L22.1099 1.15999C22.4199 0.84999 22.9199 0.84999 23.2199 1.15999C23.5199 1.46999 23.5299 1.97999 23.2199 2.28999L10.9299 14.8C10.7799 14.96 10.5799 15.03 10.3699 15.03V15.04Z"
          fill="currentColor"
        />
        <path
          d="M9.15995 20.8C9.10995 20.8 9.04995 20.8 8.98995 20.78C8.56995 20.69 8.28995 20.26 8.38995 19.83L9.60995 14.07C9.69995 13.64 10.1199 13.36 10.5399 13.46C10.9599 13.55 11.2399 13.98 11.1399 14.41L9.91995 20.17C9.83995 20.55 9.50995 20.8 9.14995 20.8H9.15995Z"
          fill="currentColor"
        />
        <path
          d="M14.8201 19.56C14.6201 19.56 14.4201 19.48 14.2601 19.33C13.9501 19.02 13.9501 18.51 14.2601 18.2L26.5601 5.69002C26.8701 5.38002 27.3701 5.38002 27.6701 5.69002C27.9701 6.00002 27.9801 6.51002 27.6701 6.82002L15.3801 19.33C15.2301 19.49 15.0201 19.56 14.8201 19.56Z"
          fill="currentColor"
        />
        <path
          d="M9.16011 20.7999C8.80011 20.7999 8.47011 20.5399 8.39011 20.1699C8.30011 19.7399 8.57011 19.3099 8.99011 19.2199L14.6601 17.9799C15.0901 17.8899 15.5001 18.1599 15.5901 18.5899C15.6801 19.0199 15.4101 19.4499 14.9901 19.5399L9.32011 20.7799C9.26011 20.7899 9.21011 20.7999 9.15011 20.7999H9.16011Z"
          fill="currentColor"
        />
        <path
          d="M24.89 9.32001C24.69 9.32001 24.49 9.24001 24.33 9.09001L19.88 4.56001C19.57 4.25001 19.57 3.74001 19.88 3.43001C20.19 3.12001 20.69 3.12001 20.99 3.43001L25.44 7.96001C25.75 8.27001 25.75 8.78001 25.44 9.09001C25.29 9.25001 25.09 9.32001 24.88 9.32001H24.89Z"
          fill="currentColor"
        />
        <path
          d="M27.1199 7.05C26.9199 7.05 26.7199 6.97 26.5599 6.82C26.2499 6.51 26.2499 6 26.5599 5.69C26.9999 5.24 27.2399 4.64 27.2399 3.99C27.2399 3.34 26.9999 2.74 26.5599 2.29C26.1199 1.84 25.5299 1.6 24.8899 1.6C24.2499 1.6 23.6599 1.85 23.2199 2.29C22.9099 2.6 22.4199 2.6 22.1099 2.29C21.7999 1.98 21.7999 1.47 22.1099 1.16C22.8399 0.41 23.8299 0 24.8899 0C25.9499 0 26.9399 0.41 27.6699 1.16C28.4099 1.91 28.8099 2.91 28.8099 3.99C28.8099 5.07 28.4099 6.07 27.6699 6.82C27.5199 6.98 27.3199 7.05 27.1099 7.05H27.1199Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
});

export const DataDownloadIcon = createIcon({
  displayName: 'DataDownloadIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="97" height="99" fill="none">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M77.92 35.89V22.44L58.87 3.07 14.38 3C10.83 3 8 5.82 8 9.36v80.13c0 3.49 2.83 6.36 6.38 6.36l57.17.09c3.52 0 6.38-2.82 6.38-6.36V76.46"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M76.55 22.64H57.67V3.18M84.22 57.61l-6.3 6.29-6.29-6.29"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M77.92 71.46c8.44 0 15.28-6.841 15.28-15.28S86.36 40.9 77.92 40.9c-8.438 0-15.28 6.841-15.28 15.28s6.842 15.28 15.28 15.28ZM77.92 62.68V48.23M21.51 34.12h41.16M21.51 45.06h37.16M21.51 55.99h35.16M21.51 66.93h37.16M21.51 77.86h41.16"
      />
    </svg>
  ),
  viewBox: '0 0 97 99',
});

export const DeleteAccountIcon = createIcon({
  displayName: 'DeleteAccountIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" width="87" height="74" fill="none">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M72 58.2c0 5.88 0 5.82-1.14 8.07a10.496 10.496 0 0 1-4.59 4.59c-.4.2-.81.37-1.27.51m-56 0c-.45-.14-.87-.3-1.27-.51a10.496 10.496 0 0 1-4.59-4.59C2 64.02 2 61.08 2 55.2V18.8c0-5.88 0-8.82 1.14-11.07 1.01-1.98 2.61-3.58 4.59-4.59C9.98 2 12.92 2 18.8 2h36.4c5.88 0 8.82 0 11.07 1.14 1.98 1.01 3.58 2.61 4.59 4.59C72 9.98 72 9.92 72 15.8M9 71.36c2.11.64 4.96.64 9.8.64h36.4c4.84 0 7.69 0 9.8-.64 0-2.83-.02-3.33-.27-4.59-1.1-5.55-5.45-9.9-11-11-1.35-.27-2.98-.27-6.23-.27h-21c-3.25 0-4.88 0-6.23.27-5.55 1.1-9.9 5.45-11 11-.25 1.26-.27 1.76-.27 4.59Zm42-38.11c0 7.73-6.27 14-14 14s-14-6.27-14-14 6.27-14 14-14 14 6.27 14 14Z"
      />
      <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3">
        <path d="M72.28 48C79.306 48 85 42.305 85 35.28s-5.694-12.72-12.72-12.72c-7.025 0-12.72 5.695-12.72 12.72S65.256 48 72.28 48ZM67.885 39.39l8.506-8.506M76.39 39.39l-8.505-8.506" />
      </g>
    </svg>
  ),
  viewBox: '0 0 87 74',
});

export const CheckmarkIcon = createIcon({
  displayName: 'CheckmarkIcon',
  viewBox: '0 0 10 10',
  path: (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.83183 10C4.13093 10 4.3623 9.87334 4.52596 9.62579L9.8307 1.19747C9.94921 1.00748 10 0.846287 10 0.690846C10 0.282096 9.71783 0 9.31151 0C9.03499 0 8.86569 0.103627 8.69639 0.374208L3.80361 8.29016L1.29233 5.00288C1.12302 4.77835 0.948081 4.68624 0.699774 4.68624C0.293454 4.68624 0 4.97985 0 5.38284C0 5.56131 0.0620768 5.73402 0.208804 5.91249L3.13205 9.63155C3.32957 9.88486 3.53837 10 3.83183 10Z"
        fill="currentColor"
      />
    </svg>
  ),
});

export const LockIcon = createIcon({
  displayName: 'LockIcon',
  viewBox: '0 0 16 18',
  path: (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9011 17.6411C13.6886 17.6411 15.1187 16.2002 15.1187 14.449V11.279C15.1187 9.7938 14.1132 8.50808 12.7055 8.1534V5.4268C12.5714 2.85538 10.5381 0.838134 7.94616 0.705129C5.17548 0.572124 2.85168 2.7002 2.73996 5.44897V8.35291C2.38245 8.50808 2.04729 8.72976 1.75682 9.01794C1.15352 9.61646 0.818359 10.4367 0.818359 11.279V14.449C0.818359 16.178 2.24839 17.6189 4.01358 17.6411H11.9011ZM4.05827 9.01794H5.24251C5.4883 9.01794 5.71174 8.81843 5.71174 8.55242V5.51547C5.75643 4.4736 6.6502 3.63124 7.74506 3.60907C8.75055 3.60907 9.57729 4.42927 9.59963 5.4268V8.06473H7.78975C7.54396 8.06473 7.32052 8.28641 7.32052 8.55242V9.70513C6.42675 9.9268 5.75643 10.7248 5.75643 11.678C5.75643 12.8086 6.67254 13.6953 7.78975 13.6953C8.92931 13.6953 9.84542 12.8086 9.84542 11.7002C9.84542 11.4785 9.80073 11.279 9.75604 11.0795C9.66666 10.8357 9.39853 10.6805 9.15275 10.7692C8.90696 10.8357 8.75055 11.1017 8.83993 11.3677C8.86227 11.4564 8.88462 11.5672 8.88462 11.678C8.88462 12.2766 8.39304 12.7642 7.78975 12.7642C7.2088 12.7642 6.71723 12.2766 6.71723 11.678C6.71723 11.0795 7.2088 10.614 7.78975 10.614C8.05788 10.614 8.28132 10.3923 8.28132 10.1263V9.01794H10.0689C10.337 9.01794 10.5381 8.79626 10.5381 8.55242V5.4268C10.5381 3.89725 9.28681 2.67804 7.72272 2.67804H7.70037C6.13628 2.67804 4.84032 3.91941 4.75094 5.49331V8.0869H3.67842V5.47114C3.74545 4.4071 4.19233 3.40956 4.99673 2.7002C5.80112 1.96868 6.82895 1.614 7.90147 1.65833C10.0018 1.747 11.6553 3.38739 11.7447 5.44897V8.55242C11.7447 8.77409 11.9234 8.9736 12.1692 9.01794C13.3088 9.15094 14.1802 10.1263 14.1802 11.279V14.449C14.1802 15.6903 13.1524 16.6879 11.9011 16.6879H4.01358C2.78465 16.6879 1.77916 15.6682 1.77916 14.449V11.279C1.77916 10.6805 2.0026 10.1041 2.42714 9.68296C2.87403 9.26178 3.43263 9.01794 4.05827 9.01794Z"
        fill="currentColor"
      />
    </svg>
  ),
});
